// index.js – Startpunkt der Webseite
// Wird als Erstes geladen. Entscheidet anhand der Adresse, welche App gezeigt wird:
//   editor.bandeleart.ch/admin… → AdminApp (Admin-Bereich für BandeleArt)
//   alles andere               → App (Editor für die Kunden)
// Die Webseite ist mit React gebaut: Die Oberfläche besteht aus „Komponenten“
// (Funktionen, die beschreiben, was angezeigt wird). React aktualisiert die Anzeige
// automatisch, wenn sich Daten ändern.
//
// React-Grundlagen, die in allen Dateien vorkommen:
//   • useState     – ein Wert, den sich eine Komponente merkt; ändert er sich, wird neu gezeichnet
//   • useEffect    – Code, der nach dem Zeichnen läuft (z.B. Daten laden, Timer starten)
//   • useMemo      – Ergebnis einer aufwendigen Berechnung zwischenspeichern
//   • useCallback  – Funktion zwischenspeichern, damit sie nicht bei jedem Zeichnen neu entsteht
//   • useRef       – Wert merken, ohne dass neu gezeichnet wird (z.B. Timer, DOM-Element)
//   • props        – Eingaben einer Komponente, z.B. <MemoCard size={300} />
//   • JSX          – das HTML-ähnliche <div>…</div> mitten im JavaScript
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './admin/AdminApp';

// Admin-Bereich, wenn die Adresse mit /admin beginnt.
const isAdmin = window.location.pathname.startsWith('/admin');

// In das <div id="root"> aus public/index.html wird die ganze Seite gezeichnet.
// StrictMode prüft während der Entwicklung auf typische Fehler (im fertigen Build ohne Wirkung).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAdmin ? <AdminApp /> : <App />}
  </React.StrictMode>
);
